export default __webpack_public_path__ + "static/media/vendas1.2ff1864e.png";